import { UPDATE, CLEAR } from "../constants/action_types.js"
const song_handler = (song = {}, action) =>
{
  switch (action.type)
  {
    case UPDATE:
      return action.payload;
    case CLEAR:
      return {};
    default:
      return song;
  }
}

export default song_handler;
